import React, { ReactNode } from "react";
import PromoPopup from "./features/promo/PromoPopup";

type WrapPageElementArgs = {
  element: ReactNode;
  props: { location: { pathname: string } };
};

const wrapPageElement = ({ element, props }: WrapPageElementArgs) => (
  <>
    {element}
    <PromoPopup pathname={props.location.pathname} />
  </>
);

export default wrapPageElement;
